package br.com.texeratx.boardgametimeapp.domain.usecases.player

import br.com.texeratx.boardgametimeapp.data.repository.PlayerRepository
import br.com.texeratx.boardgametimeapp.ui.screens.players.model.PlayerListItemUI

class GetPlayersUseCase(
    private val repository: PlayerRepository
) {
    suspend operator fun invoke(): Result<List<PlayerListItemUI>> {
        return repository.getPlayers().map { dtoList ->
            dtoList.map {
                PlayerListItemUI(
                    id = it.id,
                    name = it.name,
                    nickname = it.nickname,
                    imageUrl = it.imageUrl
                )
            }
        }
    }
}